import { createContext, useContext } from 'react'

/**
 * Where a page's breadcrumb trail is drawn: a spot in the app's top bar,
 * right after the module's name, so the trail reads as one path from the
 * module ("Integrations / Sources / Deltek Vantagepoint (Tables)") and the page
 * header keeps only the title, statuses, and tabs. The app's layouts provide
 * it; the top bar marks the spot; `PageHeader` draws its trail there. With no
 * spot (a dialog, a test), `PageHeader` keeps the trail in its own row.
 */
export interface PageTrailSlot {
  /** The element the trail is drawn into, once the top bar has mounted. */
  element: HTMLElement | null
  /** The top bar's callback ref for the spot. */
  setElement: (element: HTMLElement | null) => void
}

export const PageTrailSlotContext = createContext<PageTrailSlot | null>(null)

/** The element a page's trail should be drawn into, or null to keep it in the page header. */
export function usePageTrailSlot(): HTMLElement | null {
  return useContext(PageTrailSlotContext)?.element ?? null
}

/** The top bar's callback ref for where the trail goes (a no-op outside a layout). */
export function usePageTrailSlotRef(): (element: HTMLElement | null) => void {
  return useContext(PageTrailSlotContext)?.setElement ?? noop
}

function noop() {}
